import React from 'react';
import { EmailBlock, TemplateVariable } from '../../../../../../../types/communication';
import RichTextField from '../../../shared/RichTextField';
import VariableTextField from '../../../shared/VariableTextField';

interface EmailBlockFieldsProps {
    block: EmailBlock;
    variables: TemplateVariable[];
    disabled: boolean;
    onChange: (patch: Partial<EmailBlock>) => void;
}

const AlignToggle: React.FC<{ value: EmailBlock['align']; disabled: boolean; onChange: (align: 'left' | 'center') => void }> = ({
    value = 'left',
    disabled,
    onChange,
}) => (
    <div className="inline-flex rounded-lg border border-gray-200 dark:border-slate-600 overflow-hidden text-xs">
        {(['left', 'center'] as const).map((align) => (
            <button
                key={align}
                type="button"
                disabled={disabled}
                onClick={() => onChange(align)}
                className={`px-2.5 py-1 ${value === align ? 'bg-slate-700 text-white' : 'text-gray-600 dark:text-gray-300 hover:bg-slate-50 dark:hover:bg-slate-700'}`}
            >
                {align === 'left' ? 'À esquerda' : 'Centralizado'}
            </button>
        ))}
    </div>
);

const EmailBlockFields: React.FC<EmailBlockFieldsProps> = ({ block, variables, disabled, onChange }) => {
    if (block.kind === 'TEXT') {
        return <RichTextField value={block.text ?? ''} variables={variables} disabled={disabled} onChange={(text) => onChange({ text })} />;
    }
    if (block.kind === 'BUTTON') {
        return (
            <div className="flex flex-col gap-3">
                <div className="grid grid-cols-2 gap-3">
                    <VariableTextField id={`${block.id}-text`} label="Texto do botão" value={block.text ?? ''} disabled={disabled} onChange={(text) => onChange({ text })} />
                    <VariableTextField
                        id={`${block.id}-url`}
                        label="Link"
                        value={block.url ?? ''}
                        variables={variables}
                        disabled={disabled}
                        onChange={(url) => onChange({ url })}
                    />
                </div>
                <AlignToggle value={block.align} disabled={disabled} onChange={(align) => onChange({ align })} />
            </div>
        );
    }
    return (
        <VariableTextField
            id={block.id}
            label="Texto do rodapé"
            value={block.text ?? ''}
            variables={variables}
            disabled={disabled}
            multiline
            rows={2}
            hint="Deixe uma linha em branco para começar outro parágrafo."
            onChange={(text) => onChange({ text })}
        />
    );
};

export default EmailBlockFields;
